import { SET_CUSTOMER } from './customer.actions';

const initialState = {
  userInfo: null,
};

// TODO: merge together session, client and customer reducers in one
// under user field in redux store
export const customerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CUSTOMER:
      return {
        ...state,
        // TODO: rename userInfo to customer
        userInfo: payload,
      };
    default:
      return state;
  }
};
